// store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../Redux/user_information';

export const store = configureStore({
  reducer: {
    user: userReducer,
  },
});
